import { render, staticRenderFns } from "./PostableEquipmentDelete.vue?vue&type=template&id=60e4ab25&scoped=true"
import script from "./PostableEquipmentDelete.vue?vue&type=script&lang=js"
export * from "./PostableEquipmentDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e4ab25",
  null
  
)

export default component.exports